<template>
    <v-content>
        <v-row class="pb-0 pb-sm-2">
            <v-col class="display-1">
                Список аккаунтов рассыльщиков
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="primary" depressed @click="createAccount()">
                        <v-icon small>mdi-plus</v-icon>
                        Добавить
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-text-field
                    v-model="name"
                    @input="getMailingAccounts"
                    placeholder="Название"
                    outlined
                    hide-details
                    clearable
                    dense
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-select
                    v-model="type_of_notification"
                    @change="getMailingAccounts"
                    :items="types_of_notification"
                    item-text="name"
                    item-value="value"
                    label="Тип уведомления"
                    outlined
                    hide-details
                    clearable
                    dense
                  />
            </v-col>
            <v-col cols="4">
                <v-select
                    v-model="type_of_account"
                    @change="getMailingAccounts"
                    :items="types_of_account"
                    item-text="name"
                    item-value="value"
                    label="Тип аккаунта"
                    outlined
                    hide-details
                    clearable
                    dense
                  />
            </v-col>
        </v-row>
        <b-table
            :data="mailing_accounts.results"
            :loading="isLoading"
            paginated
            backend-pagination
            :total="mailing_accounts.total"
            :per-page="perPage.value"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
        >
            <template slot-scope="props">
                <b-table-column field="is_used" label="Используется?">
                    <b-switch v-model="props.row.is_used" @input="setIsUsed(props.row.id)"></b-switch>
                </b-table-column>

                <b-table-column field="id" label="ID" numeric sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="name" label="Название" sortable>
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column field="balance" label="Баланс">
                    {{ props.row.balance }} {{ props.row.currency }}
                </b-table-column>

                <b-table-column field="type_of_notification" label="Тип уведомления">
                    {{ props.row.type_of_notification }}
                </b-table-column>

                <b-table-column field="type_of_account" label="Тип рассыльщика">
                    {{ props.row.type_of_account }}
                </b-table-column>

                <b-table-column
                      label="Действия"
                      centered
                  >
                  <b-tooltip
                      label="Изменить">
                      <div
                          @click="updateAccount(props.row.id)">
                          <b-icon
                              icon="pencil"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                  <b-tooltip
                      label="Удалить">
                      <div
                          @click="deleteAccount(props.row.id)">
                          <b-icon
                              icon="delete"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                </b-table-column>
            </template>
            <template slot="bottom-left">
                <div class="pagination-controls">
                  <v-select
                    style="width: fit-content; float: left;"
                    v-model="perPage.value"
                    @change="getMailingAccounts"
                    :items="perPageOptions"
                    item-text="name"
                    item-value="value"
                    outlined
                    hide-details
                    dense
                  />
                </div>
            </template>
        </b-table>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: 'AccountList',
    components: {
        OverlayLoader,
    },
    data() {
        return {
            sortField: "id",
            sortOrder: "desc",
            page: 1,
            perPage: {
                value: 20,
            },
            type_of_account: '',
            type_of_notification: '',
            name: '',
            perPageOptions: [
                { name: "10 на странице", value: 10 },
                { name: "20 на странице", value: 20 },
                { name: "50 на странице", value: 50 },
                { name: "100 на странице", value: 100 },
            ],
            types_of_account: [
                {
                    name: 'Unicore',
                    value: 'unicore',
                    type: 'sms',
                },
                {
                    name: 'P1SMS',
                    value: 'p1sms',
                    type: 'sms',
                },
                {
                    name: 'Mobizon',
                    value: 'mobizon',
                    type: 'sms',
                },
                {
                    name: 'Zvonobot',
                    value: 'zvonobot',
                    type: 'call',
                },
            ],
            types_of_notification: [
                {
                    name: 'СМС',
                    value: 'sms',
                },
                {
                    name: 'Звонок',
                    value: 'call',
                },
            ]
        };
    },
    created() {
        this.getMailingAccounts();
    },
    computed: {
        mailing_accounts() {
            return this.$store.getters.MAILING_ACCOUNTS_LIST;
        },
        isLoading() {
            return this.$store.getters.MAILING_ACCOUNTS_LOADING;
        },
    },
    methods: {
        getMailingAccounts() {
            const params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                name: this.name,
                type_of_account: this.type_of_account,
                type_of_notification: this.type_of_notification,
            };
            this.$store.dispatch('GET_MAILING_ACCOUNT_LIST', params);
        },
        setIsUsed(accountId) {
            this.$store.dispatch('SET_IS_USED_MAILING_ACCOUNT', accountId)
                .finally(() => this.getSettings());
        },
        updateAccount(accountId) {
            this.$router.push({ name: "UpdateAccount", params: { id: accountId } });
        },
        createAccount() {
            this.$router.push({ name: "CreateAccount" });
        },
        deleteAccount(accountId) {
            this.$store.dispatch('DELETE_MAILING_ACCOUNT', accountId)
                .finally(() => this.getMailingAccounts());
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.getMailingAccounts();
        },
        onPageChange(page) {
            this.page = page;
            this.getMailingAccounts();
        },
    }
}
</script>

<style>

</style>
